'use client';

import ReactSelectComponents from '@/customizations/ReactSelect';
import { useEffect, useState } from 'react';
import ReactSelect from 'react-select';

const FieldWrapper = ({ className = '', children }: any) => <div className={`field-wrapper relative ${className}`}>{children}</div>;
const FieldData = ({ label, info, error }: any) => (
  <>
    {label && <label className="field-label">{label}</label>}
    {info && <div className="field-info">{info}</div>}
    {error && <span className="field-error">{error}</span>}
  </>
);

export const BasicSelect = ({
  name,
  children,
  searchable = true,
  filterOption = (candidate: { label: string; value: string; data: any }, input: string) => {
    if (input) {
      return candidate.label.toLowerCase().includes(input.toLowerCase());
    }
    return true;
  },
  options,
  value,
  unstyled = false,
  className,
  onChange,
  label,
  info,
  initialValue,
  disabled,
  icon,
  placeholder,
  styles,
  ...rest
}: any) => {
  const [option, setOption] = useState<any>(options?.find((opt: { label: string; value: string }) => opt.value === initialValue));
  const [focus, setFocus] = useState(false);
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const resolvedValue = value !== undefined ? value : initialValue;
    const foundOption = options?.find((opt: { label: string; value: string }) => opt.value === resolvedValue);
    if (foundOption?.value !== option?.value) {
      setOption(foundOption);
    }
  }, [value, options, initialValue, option]);
  useEffect(() => {
    if (!mounted) setMounted(true);
  }, []);

  return (
    <FieldWrapper {...{ name, className }}>
      <input name={name} type="hidden" value={option?.value || initialValue || ''} />
      {mounted && (
        <ReactSelect
          // onFocus={() => setFocus(true)}
          // onBlur={() => setFocus(false)}
          // onMenuOpen={() => setOpen(true)}
          onMenuClose={() => setOpen(false)}
          onChange={(selectedOption: any) => {
            setOption(selectedOption);
            if (typeof onChange === 'function') {
              onChange(selectedOption);
            }
          }}
          value={option}
          defaultValue={initialValue}
          isSearchable={searchable}
          filterOption={filterOption}
          placeholder={placeholder}
          unstyled={true}
          isDisabled={disabled}
          menuPlacement="bottom"
          components={ReactSelectComponents({ focus, open, unstyled, hasLabel: Boolean(label) })}
          options={options}
          styles={styles}
          {...rest}
        />
      )}

      <FieldData {...{ label, info }} />
    </FieldWrapper>
  );
};
